import React from 'react';
import { Box, palette, styled } from 'bumbag';
import classNames from 'classnames';
import type { ReactElement, ReactNode } from 'react';
type Props = {
  children: ReactNode;
  emptyText: string | ReactElement;
  iconName?: string | null | undefined;
  isActive: boolean;
};
const Icon = styled.i`
  font-size: 4rem;
  color: ${palette('primary')};
`;

const WithEmpty = ({ iconName, isActive, children, emptyText }: Props) => (
  <Box>
    {isActive ? (
      <Box data-testid="empty" textAlign={iconName ? 'center' : undefined}>
        {iconName && <Icon className={classNames('margin-bottom-20 margin-top-20', iconName)} />}
        {emptyText}
      </Box>
    ) : (
      children
    )}
  </Box>
);

WithEmpty.defaultProps = {
  iconName: null,
};
export default WithEmpty;
